import { forwardRef } from "react";

import {
  SKELETON_DEFAULTS,
  SKELETON_VARIANT_CLASS_MAP,
  type TSkeletonProps,
} from "@/ui/components/primitives/Skeleton/Skeleton.config";
import {
  ParagraphLines,
} from "@/ui/components/primitives/Skeleton/ParagraphLines";
import {
  SkeletonBlock,
} from "@/ui/components/primitives/Skeleton/SkeletonBlock";
import { cn } from "@/ui/lib/utils";

export const Skeleton = forwardRef<HTMLDivElement, TSkeletonProps>(
  (
    {
      className,
      variant = SKELETON_DEFAULTS.variant,
      ...props
    },
    ref,
  ) => (
    <div
      {...props}
      ref={ref}
      data-component="Skeleton"
      aria-hidden="true"
      className={cn(
        "flex animate-pulse",
        SKELETON_VARIANT_CLASS_MAP[variant],
        className,
      )}
    >
      { variant === "default" && (
        <>
          <SkeletonBlock className="size-10 shrink-0 rounded-sys-full" />
          <ParagraphLines />
        </>
      ) }
      { variant === "card" && (
        <>
          <ParagraphLines />
          <SkeletonBlock className="aspect-square w-full rounded-sys-md" />
        </>
      ) }
      { variant === "text" && (
        <>
          <SkeletonBlock className="h-4 w-full rounded-sys-md" />
          <SkeletonBlock className="h-4 w-3/4 rounded-sys-md" />
        </>
      ) }
    </div>
  ),
); Skeleton.displayName = "Skeleton";
